export default __webpack_public_path__ + "static/media/add-name.acf68bbf.jpg";